export default __webpack_public_path__ + "static/media/plain-sticker-E.5e684393.png";